// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Xm-z","tupacHeader":"Ym-z","tupacHeader2":"Zm-z","tupacMenu":"_m-z","tupacMenu2":"an-z","tupacMain":"bn-z","tupacMain2":"cn-z"};